import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const MonthlyTrendsChart = ({ trends }) => {
    if (!trends || trends.length === 0) return null;

    const chartData = {
        labels: trends.map(trend => trend.month),
        datasets: [
            {
                label: 'Total SFAs',
                data: trends.map(trend => trend.total_sfas),
                borderColor: 'rgb(75, 192, 192)',
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                tension: 0.1,
                fill: false
            },
            {
                label: 'Completed SFAs',
                data: trends.map(trend => trend.completed_sfas),
                borderColor: 'rgb(54, 162, 235)',
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
                tension: 0.1,
                fill: false
            },
            {
                label: 'Approved SFAs',
                data: trends.map(trend => trend.approved_sfas),
                borderColor: 'rgb(255, 99, 132)',
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                tension: 0.1,
                fill: false
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'SFA Applications - Monthly Trends'
            },
            tooltip: {
                mode: 'index',
                intersect: false,
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                title: {
                    display: true,
                    text: 'Number of Applications'
                }
            },
            x: {
                title: {
                    display: true,
                    text: 'Month'
                }
            }
        },
        interaction: {
            mode: 'nearest',
            axis: 'x',
            intersect: false
        }
    };

    return (
        <div className="card">
            <div className="card-header">
                <h3 className="card-title">
                    <i className="fas fa-chart-line mr-2"></i>
                    Monthly Trends
                </h3>
                <div className="card-tools">
                    <span className="badge badge-info">Last 12 Months</span>
                </div>
            </div>
            <div className="card-body">
                <div style={{ height: '300px', position: 'relative' }}>
                    <Line data={chartData} options={options} />
                </div>
                
                {/* Summary Stats */}
                <div className="row mt-3">
                    <div className="col-md-4">
                        <div className="text-center">
                            <h6 className="text-muted">Total Applications</h6>
                            <h4 className="text-primary">
                                {trends.reduce((sum, trend) => sum + trend.total_sfas, 0)}
                            </h4>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="text-center">
                            <h6 className="text-muted">Completed</h6>
                            <h4 className="text-success">
                                {trends.reduce((sum, trend) => sum + trend.completed_sfas, 0)}
                            </h4>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="text-center">
                            <h6 className="text-muted">Approved</h6>
                            <h4 className="text-info">
                                {trends.reduce((sum, trend) => sum + trend.approved_sfas, 0)}
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MonthlyTrendsChart; 